import React, { useState,useEffect,useCallback } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Sidebar from './Sidebar';
import Header from './Header';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { useDispatch, useSelector } from 'react-redux';
import Table from 'react-bootstrap/Table';
import Spinner from 'react-bootstrap/Spinner';
import Pagination from 'react-bootstrap/Pagination';
import debounce from "lodash/debounce";
import { deleteApplication, fetchApplications, filterApplications, updateApplication } from '../redux/actions/applicationsActions';

function ReceivedAplication() {
    const sidebarState = useSelector(state => state.sidebarReducres);
    const applications = useSelector(state=> state.applicationsReducer.applications)
    const [loading,setLoading] = useState(true);
    const [searchText,setSearchText] = useState('')
    const [error,setError] = useState("");
    const [currentPage,setCurrentPage] = useState(1);
    const [displayPages,setDisplayPages] = useState([])
    const [totalPages,setTotalPages] = useState(0)
    const [searchType,setSearchType] = useState("name")
    const dispatch = useDispatch()

    useEffect(()=>{
        onFetchApplications({page:1})
    },[])

    const onFetchApplications = async(params) =>{
        setLoading(true)
        if(params && params.offsetZero){
            setCurrentPage(1)
		}
        const queryParams = {
			start: params.offsetZero ? 0 : (10*(params.page-1)),
			end: (params.page*10)-1,
		};
        const res = await dispatch(fetchApplications(queryParams))
        if(res.success){
            const totalCount = res?.data?.length > 0 ? res?.count : 1;
            setTotalPages(Math.ceil(totalCount / 10))
            generateDisplayPages(Math.ceil(totalCount / 10),params.page)
            setLoading(false)
        }else if(!res.success){
            setLoading(false)
        }
    }

    const onDelete = async(item) =>{
        setLoading(true)
        const res = await dispatch(deleteApplication(item.id))
        if(res.success){
            if(searchText.trim().length>=3){
                await handleSearch(searchText)
            }else{
                await onFetchApplications({page:1,offsetZero:true})
            }
            setLoading(false)
        }
    }

    const onChangeStatus = async(e)=>{
        setLoading(true)
        const applicationdata = {id:e.target.id,status:e.target.value=="on"?false:true}
        const res = await dispatch(updateApplication(applicationdata))
        if(res.success){
            setCurrentPage(1)
            if(searchText.trim().length>=3){
                await handleSearch(searchText)
            }else{
                await onFetchApplications({page:1,offsetZero:true})
            }
            setLoading(false)
        }
    }

    const downloadFileUrl = (url) =>{
        const aTag= document.createElement("a");
        aTag.href = `https://brbddsnivuyhonwzrjic.supabase.co/storage/v1/object/public/Resumes/${url}`
        aTag.setAttribute("download",url)
        aTag.target ="_blank"
        document.body.appendChild(aTag)
        aTag.click();
        aTag.remove();
    }

    const handleSearch = async(query,page)=>{
        setSearchText(query)
        if(query.trim().length >= 3){
        setLoading(true)
        let res;
        if(!page){
            setCurrentPage(1)
        }
        const start = page ? (10*(page-1)): 0
		const end = page ? (page*10)-1:9
        if(query.trim().length){
            res = await dispatch(filterApplications({search:query.trim(),start,end}))
        }else{
            await onFetchApplications({page:1})
            setLoading(false)
        }
        if(res && res.success){
            const totalCount = res?.data?.length > 0 ? res?.count : 1;
            setTotalPages(Math.ceil(totalCount / 10))
            generateDisplayPages(Math.ceil(totalCount / 10),currentPage)
            setLoading(false)
        }else if(res && !res.success){
            setLoading(false)
        }
        }else if(query.trim().length === 0){
            let res;
            setLoading(true)
            await onFetchApplications({page:1})
            setLoading(false)
            if(res && res.success){
                setLoading(false)
            }else if(res && !res.success){
                setLoading(false)
            }
        }
    }

    const debouncedHandleSearch = useCallback(debounce(handleSearch, 200), []);

    const handlePaginationChange = async(params) => {
        if(params && params.offsetZero){
			setCurrentPage(1)
		}
        setCurrentPage(params.page)
        if(searchText.trim().length>3){
            await handleSearch(searchText,params.page)
        }else{
            await onFetchApplications(params)
        }
	};

    const renderPaginationItems = () => {
		return (
			<>
				<Pagination className="ml-auto">
					<Pagination.Prev disabled={currentPage == 1} onClick={() => handlePaginationChange({page:currentPage-1})} />
					{displayPages.map((page, index) => (
						<React.Fragment key={index}>
							{page === '...' ? (
								<Pagination.Ellipsis className='pagination-elipsis-disabled' />
							) : (
								<Pagination.Item
									className={page !== '...' ? 'pagination-number' : ''}
									active={page === currentPage}
									onClick={() => (page !== '...' && page!==currentPage && handlePaginationChange({page:page}))}
								>
									{page}
								</Pagination.Item>
							)}
						</React.Fragment>
					))}
					<Pagination.Next disabled={currentPage == totalPages}  onClick={() => handlePaginationChange({page:currentPage+1})} />
				</Pagination>
			</>
		);
	}

    const generateDisplayPages = (totalPages,currentPage) => {
		const displayPages = [];
		if (totalPages <= 5) {
			for (let i = 1; i <= totalPages; i++) {
				displayPages.push(i);
			}
		} else {
			if (currentPage <= 2) {
				for (let i = 1; i <= 3; i++) {	
					displayPages.push(i);
				}
				displayPages.push('...');
				displayPages.push(totalPages);
			} else if (currentPage >= totalPages - 1) {
				displayPages.push(1);
				displayPages.push('...');
				for (let i = totalPages - 2; i <= totalPages; i++) {
					displayPages.push(i);
				}
			} else {
				displayPages.push(1);
				if(currentPage>=4){
					displayPages.push('...')
				}
				for (let i = currentPage - 1; i <= currentPage + 1; i++) {
					displayPages.push(i);
				}
				if(currentPage<=totalPages-3){
					displayPages.push('...');
				}
				displayPages.push(totalPages);
			}
		}
		setDisplayPages(displayPages)
	}

    return (
        <>
        <Sidebar/>
        <Header/>
        <div className={`main-content ${!sidebarState ? '' : 'navbar-ful'}`}>
                <div className='page-content'>
                    <Container fluid>
                        <Row>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className='p-0'>
                                <Card>
                                    <Card.Body>
                                        <div className='mb-3 d-flex align-items-center justify-content-between'>
                                            <div>
                                                <h5 className='d-inline-block mb-0'>Received Aplication</h5>
                                            </div>
                                            <div className='rightside-filter'>
                                                <input type="search" value={searchText} name="search" className='form-control w-auto d-inline' placeholder='Search...' onChange={(e) => debouncedHandleSearch(e.target.value)}/>
                                            </div>
                                        </div>
                                        <hr className='m-0'/>
                                        {!loading?<>
                                        <Table striped hover size="xxl">
                                            <thead>
                                                <tr>
                                                <th>ID</th>
                                                <th>Date</th>
                                                <th>Name</th>
                                                <th>Mobile</th>
                                                <th>Email</th>
                                                <th>Position</th>
                                                <th>Reference</th>
                                                <th>File</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {applications?.map((item,index)=>{
                                                    return(
                                                    <tr key={index}>
                                                    <td>{item?.id}</td>
                                                    <td>{new Date(item?.created_at).getDate() + '-' +  (new Date(item?.created_at).getMonth()+1) + '-' + new Date(item?.created_at).getFullYear()}</td>
                                                    <td>{item?.name}</td>
                                                    <td>{item?.phone}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.position}</td>
                                                    <td>{item?.reference}</td>
                                                    <td className='cv'>Resume <i onClick={()=>downloadFileUrl(item?.resume)} className='fa fa-download'></i></td>
                                                    <td>
                                                        <Form.Check
                                                            name='status' 
                                                            checked={item?.status}
                                                            value={item?.status?"on":"off"}
                                                            onChange={(e)=>onChangeStatus(e)}
                                                            type="switch"
                                                            id={item?.id}
                                                            className='togg-size switch-table'
                                                        /> 
                                                    </td>
                                                    <td className='action'>
                                                        <i onClick={()=>onDelete(item)} className='fa fa-trash'></i>
                                                    </td>
                                                    </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                        {renderPaginationItems()}
                                    </>:<div className='spinner'><Spinner animation="grow"/></div>}
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
        </div>
        </>
    );
}

export default ReceivedAplication;